// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.99987 5.4999C1.99996 3.56696 3.567 2 5.49993 2C7.08542 2 8.42475 3.05424 8.85504 4.5H15.1449C15.5752 3.05425 16.9145 2 18.5 2C20.433 2 22 3.567 22 5.5C22 7.433 20.433 9 18.5 9C16.9145 9 15.5752 7.94574 15.1449 6.5H8.85503C8.78575 6.73276 8.69291 6.95537 8.57927 7.16507L16.8347 15.4205C17.3299 15.1522 17.8971 14.9998 18.4999 14.9998C20.4329 14.9998 22 16.5668 22 18.4999C22 20.4329 20.4329 22 18.4999 22C16.5668 22 14.9998 20.4329 14.9998 18.4999C14.9998 17.8971 15.1521 17.3299 15.4205 16.8347L7.16502 8.57924C6.95526 8.69291 6.73258 8.78577 6.49976 8.85506V15.1449C7.94551 15.5752 8.99999 16.9144 8.99999 18.5C8.99999 20.4331 7.43281 22 5.49987 22C3.56693 22 1.99976 20.4331 1.99976 18.5C1.99976 16.9145 3.05401 15.5752 4.49976 15.1449V8.85505C3.05401 8.42475 1.9998 7.08538 1.99987 5.4999Z"}}]};

const SitemapFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sitemap-filled',
    ref,
    icon: element,
  },
));

SitemapFilledIcon.displayName = 'SitemapFilledIcon';

export default SitemapFilledIcon;
